import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const PortUsbMicroBIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_319"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_319)">
        <path
          d="M3.44524 8.79724C3.44524 8.71036 3.51567 8.63993 3.60255 8.63993H12.5688C12.6557 8.63993 12.7261 8.71036 12.7261 8.79724V10.6849C12.7261 10.7718 12.6557 10.8422 12.5688 10.8422H3.60255C3.51567 10.8422 3.44524 10.7718 3.44524 10.6849V8.79724Z"
          fill={color}
        />
        <path
          d="M4.54637 7.97025C4.54637 7.88337 4.61679 7.81295 4.70367 7.81295H5.80479C5.89167 7.81295 5.9621 7.88337 5.9621 7.97025V9.85789C5.9621 9.94477 5.89167 10.0152 5.80479 10.0152H4.70367C4.61679 10.0152 4.54637 9.94477 4.54637 9.85789V7.97025Z"
          fill={color}
        />
        <path
          d="M6.43401 7.97025C6.43401 7.88337 6.50444 7.81295 6.59131 7.81295H7.69244C7.77931 7.81295 7.84974 7.88337 7.84974 7.97025V9.85789C7.84974 9.94477 7.77931 10.0152 7.69244 10.0152H6.59131C6.50444 10.0152 6.43401 9.94477 6.43401 9.85789V7.97025Z"
          fill={color}
        />
        <path
          d="M8.32165 7.97025C8.32165 7.88337 8.39208 7.81295 8.47895 7.81295H9.58008C9.66695 7.81295 9.73738 7.88337 9.73738 7.97025V9.85789C9.73738 9.94477 9.66695 10.0152 9.58008 10.0152H8.47895C8.39208 10.0152 8.32165 9.94477 8.32165 9.85789V7.97025Z"
          fill={color}
        />
        <path
          d="M10.2093 7.97025C10.2093 7.88337 10.2797 7.81295 10.3666 7.81295H11.4677C11.5546 7.81295 11.625 7.88337 11.625 7.97025V9.85789C11.625 9.94477 11.5546 10.0152 11.4677 10.0152H10.3666C10.2797 10.0152 10.2093 9.94477 10.2093 9.85789V7.97025Z"
          fill={color}
        />
        <path
          d="M1.08569 8.39048C1.08569 8.34876 1.10227 8.30875 1.13177 8.27925L3.55647 5.85454C3.58597 5.82504 3.62598 5.80847 3.6677 5.80847H12.4115C12.4984 5.80847 12.5688 5.8789 12.5688 5.96578V6.28038C12.5688 6.36726 12.4984 6.43769 12.4115 6.43769H3.98231C3.94059 6.43769 3.90058 6.45426 3.87108 6.48376L1.76098 8.59386C1.73148 8.62336 1.71491 8.66337 1.71491 8.70509V10.6849C1.71491 10.7718 1.64448 10.8422 1.5576 10.8422H1.243C1.15612 10.8422 1.08569 10.7718 1.08569 10.6849V8.39048Z"
          fill={color}
        />
        <path
          d="M15.0857 8.39048C15.0857 8.34876 15.0691 8.30875 15.0396 8.27925L12.6149 5.85454C12.5854 5.82504 12.5454 5.80847 12.5037 5.80847H3.75985C3.67297 5.80847 3.60255 5.8789 3.60255 5.96578V6.28038C3.60255 6.36726 3.67297 6.43769 3.75985 6.43769H12.1891C12.2308 6.43769 12.2708 6.45426 12.3003 6.48376L14.4104 8.59386C14.4399 8.62336 14.4565 8.66337 14.4565 8.70509V10.6849C14.4565 10.7718 14.5269 10.8422 14.6138 10.8422H14.9284C15.0153 10.8422 15.0857 10.7718 15.0857 10.6849V8.39048Z"
          fill={color}
        />
        <path
          d="M12.4306 5.9197L12.2082 6.14216C12.1467 6.20359 12.1467 6.30319 12.2082 6.36462L14.5143 8.67077C14.5757 8.7322 14.6753 8.7322 14.7368 8.67077L14.9592 8.44831C15.0207 8.38688 15.0207 8.28728 14.9592 8.22585L12.6531 5.9197C12.5916 5.85827 12.4921 5.85827 12.4306 5.9197Z"
          fill={color}
        />
        <path
          d="M14.9284 10.213C15.0153 10.213 15.0857 10.2834 15.0857 10.3703V10.6849C15.0857 10.7718 15.0153 10.8422 14.9284 10.8422H1.243C1.15612 10.8422 1.08569 10.7718 1.08569 10.6849L1.08569 10.3703C1.08569 10.2834 1.15612 10.213 1.243 10.213L14.9284 10.213Z"
          fill={color}
        />
        <path
          d="M12.4115 5.80847C12.4984 5.80847 12.5688 5.8789 12.5688 5.96578V6.28038C12.5688 6.36726 12.4984 6.43769 12.4115 6.43769L3.75985 6.43769C3.67297 6.43769 3.60255 6.36726 3.60255 6.28038V5.96578C3.60255 5.8789 3.67297 5.80847 3.75985 5.80847L12.4115 5.80847Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

PortUsbMicroBIcon.displayName = "PortUsbMicroBIcon";
